import React from 'react';
import { Button } from '@mui/material';
import { RiEyeFill, RiEyeOffFill } from 'react-icons/ri';
import { useTranslation } from 'services/localization';

interface Props {
	checked: boolean;
	onChange: (checked: boolean) => void;
	disabled?: boolean;
}
const VisibilitySwitch = (props: Props) => {
	const { t } = useTranslation();
	const { checked, onChange, disabled } = props;

	return (
		<Button
			startIcon={checked ? <RiEyeFill /> : <RiEyeOffFill />}
			onClick={() => onChange(!checked)}
			color="primary"
			disabled={disabled}
			sx={{
				filter: disabled || !checked ? 'grayscale(100%)' : 'grayscale(0%)',
				opacity: disabled || !checked ? 0.5 : 1,
			}}
		>
			{checked ? t('common:states.visible', 'Visible') : t('common:states.hidden', 'Hidden')}
		</Button>
	);
};

export default VisibilitySwitch;
